import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './loading.css';

const LOADING_CONTAINER_CLASS = 'loading-container';

const LOADER_OUTER_CLASS = 'loader loader-active';
const LOADER_INNER_CLASS = 'loader-inner ball-pulse';

class Loader extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;

    return <div className={LOADER_OUTER_CLASS + (className ? ' ' + className : '')}>
      <div className={LOADER_INNER_CLASS}>
        <div />
        <div />
        <div />
      </div>
    </div>
  }
}

export class Spinner extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    loaderClassName: PropTypes.string
  };

  render() {
    const { className, loaderClassName } = this.props;

    return (
      <div className={LOADING_CONTAINER_CLASS + (className ? ' ' + className : '')}>
        <Loader className={loaderClassName}/>
      </div>
    );
  }
}

export class Empty extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;
    return (
      <div className={LOADING_CONTAINER_CLASS + (className ? ' ' + className : '')}>
      </div>
    );
  };
}

export class DelayedSpinner extends PureComponent {
  static propTypes = {
    emptyTimeout: PropTypes.number,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { emptyTimeout, className } = this.props;

    return (
      <DelayedChildWrapper delayTimeout={emptyTimeout} delayedElement={Spinner}/>
    );
  }
}

export class DelayedChildWrapper extends PureComponent {

  static propTypes = {
    initialElement: PropTypes.func,
    delayedElement: PropTypes.func,
    delayTimeout: PropTypes.number,
  };

  static defaultProps = {
    initialElement: Empty,
    delayTimeout: 1000
  };

  constructor(props) {
    super(props);
    const { initialElement, delayedElement, delayTimeout } = props;
    this.delayTimeout = undefined;
    this.state = {
      Child: delayTimeout !== 0 ? initialElement : delayedElement
    };
  }

  componentDidMount() {
    const { delayedElement, delayTimeout } = this.props;
    if (delayTimeout !== 0) {
      this.delayTimeout = setTimeout(() => this.setState({ Child: delayedElement }), delayTimeout);
    }
  }

  componentWillUnmount() {
    if (this.delayTimeout !== void 0) {
      clearTimeout(this.delayTimeout);
      this.delayTimeout = void 0;
    }
  }

  render() {
    const { initialElement, delayedElement, delayTimeout, ...otherProps } = this.props;
    const { Child } = this.state;
    return (
      <Child {...otherProps}/>
    );
  }
}
